/** Rule-based Overview insight banners — tune without UI churn. */
export const OVERVIEW_RTO_ATTENTION_PCT = 25
export const OVERVIEW_USAGE_WARNING_PCT = 85
